import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            model: {
                orderNumber: 0,
                name: '',
                enName: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
                imageHeader: null,
                imageMain: '',
                type: 'KNOWLEDGE',
                locations: null,
                playingVideo: null,
                additionalInfo: {
                    videoLink: null
                },
            },
        }
    },
    methods: {
        getItem: getItem,
        getName: getName,
        getShortDesc: getShortDesc,
        getLongDesc: getLongDesc,
        formatLinks(text) {
            if (!text) return '';

            // Regex koji prepoznaje http/https linkove
            const urlRegex = /(https?:\/\/[^\s]+)/g;

            // Pretvaranje linkova u kliktabilne <a> tagove
            return text.replace(urlRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            });
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },

    },

    created() {

    },

    beforeMount() {
        this.role = session.getRole();
        this.id = this.$route.query.id;
        this.getItem();
    },


    watch: {

    }
}

function getItem(){
    let _self = this;
    AdminApiService.getCompanyInfoById(this.id)
        .then((response) => {
            let addInfo = JSON.parse(response.data.additionalInfo)
            _self.imageUrl = response.data.imageMain
            _self.model.name = response.data.name
            _self.model.orderNumber = response.data.orderNumber
            _self.model.enName = response.data.enName
            _self.model.shortDescription = response.data.shortDescription
            _self.model.enShortDescription = response.data.enShortDescription
            _self.model.longDescription = response.data.longDescription
            _self.model.enLongDescription = response.data.enLongDescription
            _self.model.imageMain = response.data.imageMain
            _self.model.locations = response.data.locations
            _self.model.additionalInfo.videoLink = addInfo.videoLink
            _self.model.playingVideo = addInfo.videoLink;
            _self.selectedCustomCategories = response.data.locations == null ? [] : response.data.locations.split(";").filter(e => e.length > 0)
        })
        .catch((error) => {
            console.log(error);
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getLongDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}


// WEBPACK FOOTER //
// ./src/components/Home/Knowledge/KnowledgeDetails.js